import { useRef, useEffect, ReactNode } from 'react';
import { TabPanel as AriaTabPanel } from 'react-aria-components';
import RegionsList from '@pages/sales-network/shared/RegionsList';
import { CountryEnum } from '@api/types/CountryEnum';



interface TabPanelProps {
	country: CountryEnum,
	children: ReactNode,
	selectedRegion: string,
}


const TabPanel = (props: TabPanelProps): JSX.Element => {
	const { country, children, selectedRegion } = props;

	const footerRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (selectedRegion !== '') {
			setTimeout(() => footerRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ selectedRegion, footerRef ]);
	
	
	return (
		<AriaTabPanel id={country}>
			<div className='info-item'>
				<p>Najděte pohodlně veterinární ordinaci ve&nbsp;Vašem kraji.</p>
			</div>

			{children}

			<RegionsList
				selectedRegion={selectedRegion}
				country={country} />

			<div className='sales-network-footer' ref={footerRef}></div>
		</AriaTabPanel>
	);
};

export default TabPanel;